'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        width: 60px;\n        height: 60px;\n    '], ['\n        width: 60px;\n        height: 60px;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactBodymovin = require('react-bodymovin');

var _reactBodymovin2 = _interopRequireDefault(_reactBodymovin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var unfavoritingAnimation = {
    v: '5.1.1',
    fr: 29.9700012207031,
    ip: 0,
    op: 66.0000026882351,
    w: 50,
    h: 50,
    nm: 'Paint-Icon-AE',
    ddd: 0,
    assets: [],
    layers: [{
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: 'paint Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 25, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 1,
                    k: [{
                        i: {
                            x: 0.3,
                            y: 1
                        },
                        o: {
                            x: 0.167,
                            y: 0.167
                        },
                        n: '0p3_1_0p167_0p167',
                        t: 2,
                        s: [{
                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.729, 2.705], [5.371, 4.346], [7.012, 2.705], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
                            c: true
                        }],
                        e: [{
                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
                            c: true
                        }]
                    }, {
                        i: {
                            x: 0.3,
                            y: 1
                        },
                        o: {
                            x: 0.167,
                            y: 0
                        },
                        n: '0p3_1_0p167_0',
                        t: 21,
                        s: [{
                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
                            c: true
                        }],
                        e: [{
                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
                            c: true
                        }]
                    }, {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.167,
                            y: 0
                        },
                        n: '0p667_1_0p167_0',
                        t: 27,
                        s: [{
                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.742, 6.674], [5.384, 8.314], [7.025, 6.674], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
                            c: true
                        }],
                        e: [{
                            i: [[0, 0], [0, 0], [0, -0.58], [0, 0], [0.581, 0], [0, 0.581], [0, 0], [0.58, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -0.716], [0, 0], [-0.715, 0], [-0.005, 0.712], [0, 0], [-0.502, 0], [0, -0.501], [0, 0], [-0.907, 0], [0, 0.906], [0, 0], [-0.503, 0], [0, 0]],
                            o: [[0, 0], [-0.581, 0], [0, 0], [0, 0.581], [-0.58, 0], [0, 0], [0, -0.58], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.715, 0], [0, 0], [0, 0.715], [0.713, 0], [0, 0], [0, -0.501], [0.503, 0], [0, 0], [0, 0.906], [0.906, 0], [0, 0], [0, -0.502], [0, 0], [0, 0]],
                            v: [[8.699, -7.877], [4.158, -7.877], [3.107, -6.826], [3.107, -6.541], [2.055, -5.489], [1.003, -6.541], [1.003, -6.826], [-0.048, -7.877], [-8.699, -7.877], [-8.699, -2.138], [-5.238, -2.138], [-4.271, -3.814], [-3.303, -2.138], [-1.973, -2.138], [-0.678, -0.843], [-0.678, 0.292], [0.617, 1.587], [1.913, 0.3], [1.924, -1.419], [2.833, -2.328], [3.743, -1.419], [3.729, 2.705], [5.371, 4.346], [7.012, 2.705], [7.027, -1.229], [7.936, -2.138], [8.699, -2.138]],
                            c: true
                        }]
                    }, {
                        t: 49.0000019958109
                    }],
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [13.43, 33.123],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 66.0000026882351,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: 'Paint Splotch Outlines',
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [{
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 20,
                    s: [0],
                    e: [100]
                }, {
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 21,
                    s: [100],
                    e: [100]
                }, {
                    i: {
                        x: [0.833],
                        y: [0.833]
                    },
                    o: {
                        x: [0.167],
                        y: [0.167]
                    },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 34,
                    s: [100],
                    e: [0]
                }, {
                    t: 37.0000015070409
                }],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [{
                    i: {
                        x: 0.667,
                        y: 1
                    },
                    o: {
                        x: 0.333,
                        y: 0
                    },
                    n: '0p667_1_0p333_0',
                    t: 18,
                    s: [25, 25, 0],
                    e: [25, 33, 0],
                    to: [0, 1.33333337306976, 0],
                    ti: [0, -1.33333337306976, 0]
                }, {
                    t: 34.0000013848484
                }],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -0.897], [0.897, 0], [0, 0.897], [-0.897, 0]],
                        o: [[0, 0.897], [-0.897, 0], [0, -0.897], [0.897, 0]],
                        v: [[1.625, 0], [0, 1.625], [-1.625, 0], [0, -1.625]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [18.771, 39.243],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 66.0000026882351,
        st: 0,
        bm: 0
    }, {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: 'everything else Outlines',
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [25, 25, 0],
                ix: 2
            },
            a: {
                a: 0,
                k: [25, 25, 0],
                ix: 1
            },
            s: {
                a: 0,
                k: [100, 100, 100],
                ix: 6
            }
        },
        ao: 0,
        shapes: [{
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0]],
                        o: [[0, 0], [0, 0]],
                        v: [[4.731, 21.599], [22.13, 21.599]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [-3.078, 0], [1.54, 2.666]],
                        o: [[0, 0], [-1.54, 2.666], [3.079, 0], [0, 0]],
                        v: [[-0.001, -5.999], [-3.464, 0.001], [-0.001, 5.999], [3.464, 0.001]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 0.773000021542, 0.039000002543, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [30.776, 10.356],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 2',
            np: 3,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0.446], [2.238, -0.407], [0.286, -1.361], [-0.164, -0.544], [0, -2.526], [0, 0], [0, 0], [0, 0], [-0.991, 2.559]],
                        o: [[0, -2.163], [-1.367, 0.248], [-0.13, 0.622], [0.726, 2.419], [0, 0], [0, 0], [0, 0], [0, -2.744], [0.151, -0.392]],
                        v: [[3.55, -3.377], [-0.637, -6.841], [-3.42, -4.136], [-3.352, -2.37], [-2.007, 5.025], [-2.007, 7.248], [2.058, 7.248], [2.058, 5.972], [3.316, -2.114]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [13.405, 8.071],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 3,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [1.138, 0], [0, 0], [0, -1.138], [0, 0]],
                        o: [[0, 0], [0, -1.138], [0, 0], [-1.138, 0], [0, 0], [0, 0]],
                        v: [[8.699, 7.228], [8.699, -5.168], [6.639, -7.228], [-6.639, -7.228], [-8.699, -5.168], [-8.699, 2.698]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [13.43, 22.547],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 4',
            np: 3,
            cix: 2,
            ix: 4,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0]],
                        o: [[0, 0]],
                        v: [[4.731, 25.246]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 5',
            np: 2,
            cix: 2,
            ix: 5,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [],
                        o: [],
                        v: [],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [0.5, 0.5],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 6',
            np: 2,
            cix: 2,
            ix: 6,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [-0.85, 0], [0, 0], [0, -0.85]],
                        o: [[0, 0], [0, 0], [0, -0.85], [0, 0], [0.85, 0], [0, 0]],
                        v: [[8.699, 2.561], [-8.699, 2.561], [-8.699, -1.021], [-7.161, -2.561], [7.16, -2.561], [8.699, -1.021]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [13.43, 17.88],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 7',
            np: 3,
            cix: 2,
            ix: 7,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -0.595], [0.594, 0], [0, 0.594], [-0.595, 0]],
                        o: [[0, 0.594], [-0.595, 0], [0, -0.595], [0.594, 0]],
                        v: [[1.076, 0.001], [0.001, 1.076], [-1.076, 0.001], [0.001, -1.076]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [42.979, 28.7],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 8',
            np: 2,
            cix: 2,
            ix: 8,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -0.595], [0.595, 0], [0, 0.594], [-0.594, 0]],
                        o: [[0, 0.594], [-0.594, 0], [0, -0.595], [0.595, 0]],
                        v: [[1.076, 0.001], [-0.001, 1.076], [-1.076, 0.001], [-0.001, -1.076]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [28.34, 28.7],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 9',
            np: 2,
            cix: 2,
            ix: 9,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [3.991, 0], [0, 3.99], [0, 0]],
                        o: [[0, 0], [0, 3.99], [-3.99, 0], [0, 0], [0, 0]],
                        v: [[7.225, -6.654], [7.225, -0.572], [-0.001, 6.654], [-7.225, -0.572], [-7.225, -6.654]],
                        c: false
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [36.452, 36.131],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 10',
            np: 2,
            cix: 2,
            ix: 10,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                        v: [[7.632, 4.156], [-7.632, 4.156], [-7.632, -4.156], [7.632, -4.156]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0, 0.458999992819, 0.788000009574, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [34.044, 36.131],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 11',
            np: 3,
            cix: 2,
            ix: 11,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0.534, 0], [0, 0], [0, 0.534], [0, 0], [-0.534, 0], [0, 0], [0, -0.535], [0, 0]],
                        o: [[0, 0], [-0.534, 0], [0, 0], [0, -0.535], [0, 0], [0.534, 0], [0, 0], [0, 0.534]],
                        v: [[11.8, 1.209], [-11.801, 1.209], [-12.768, 0.241], [-12.768, -0.241], [-11.801, -1.209], [11.8, -1.209], [12.768, -0.241], [12.768, 0.241]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [30.488, 22.808],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 12',
            np: 3,
            cix: 2,
            ix: 12,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0.553, 0], [0, 0], [0, 0.553], [0, 0], [0, 0], [0, 0]],
                        o: [[0, 0], [-0.552, 0], [0, 0], [0, 0], [0, 0], [0, 0.553]],
                        v: [[10.188, 12.117], [-10.188, 12.117], [-11.188, 11.117], [-11.188, -12.117], [11.188, -12.117], [11.188, 11.117]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'st',
                c: {
                    a: 0,
                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
                    ix: 3
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 1,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                nm: 'Stroke 1',
                mn: 'ADBE Vector Graphic - Stroke',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [30.488, 36.133],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 13',
            np: 3,
            cix: 2,
            ix: 13,
            mn: 'ADBE Vector Group',
            hd: false
        }, {
            ty: 'gr',
            it: [{
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [[0, -11.907], [11.907, 0], [0, 11.907], [-11.907, 0]],
                        o: [[0, 11.907], [-11.907, 0], [0, -11.907], [11.907, 0]],
                        v: [[21.559, 0], [0.001, 21.559], [-21.559, 0], [0.001, -21.559]],
                        c: true
                    },
                    ix: 2
                },
                nm: 'Path 1',
                mn: 'ADBE Vector Shape - Group',
                hd: false
            }, {
                ty: 'fl',
                c: {
                    a: 0,
                    k: [0.902000038297, 0.902000038297, 0.902000038297, 1],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                nm: 'Fill 1',
                mn: 'ADBE Vector Graphic - Fill',
                hd: false
            }, {
                ty: 'tr',
                p: {
                    a: 0,
                    k: [25.071, 25.898],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 6
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 7
                },
                sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                },
                nm: 'Transform'
            }],
            nm: 'Group 14',
            np: 2,
            cix: 2,
            ix: 14,
            mn: 'ADBE Vector Group',
            hd: false
        }],
        ip: 0,
        op: 66.0000026882351,
        st: 0,
        bm: 0
    }],
    markers: []
};


var PaintIcon = function PaintIcon(_ref) {
    var autoplay = _ref.autoplay;


    var PaintIconContainer = _styledComponents2.default.div(_templateObject);

    var bodymovinOptions = {
        loop: true,
        autoplay: { autoplay: autoplay },
        prerender: true,
        animationData: unfavoritingAnimation
    };

    return _react2.default.createElement(
        PaintIconContainer,
        null,
        _react2.default.createElement(_reactBodymovin2.default, { options: bodymovinOptions })
    );
};

exports.default = PaintIcon;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Icons/PaintIcon.js
// module id = 477
// module chunks = 168179225184413